import React from "react";
import styles from "../../pages/styles";

const FreeTrialPrograms = () => {
  return (
    <div className="flex flex-col items-center pt-2 pb-8 md:pt-4 md:pb-10 px-2 md:px-16 lg:px-24">
      <div className="text-center max-w-4xl mb-6 md:mb-8 px-2 md:px-4">
        <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>
          Flexible & Affordable Pricing
        </h2>
        <div className="flex flex-row items-center justify-center gap-2 md:gap-6 mb-3">
          <div className="flex-1 min-w-0">
            <p className="text-[10px] md:text-xs text-gray-500 mb-1">Starting at</p>
            <p className={`${styles.paragraph} mb-1`}>
              <span className="text-2xl md:text-3xl font-bold text-darkprimary">$240</span>
              <span className="text-xs md:text-base text-gray-600">/month</span>
            </p>
            <p className="text-[10px] md:text-sm text-gray-600">with annual commitment</p>
          </div>
          
          <div className="w-px h-12 md:h-16 bg-gray-400 mx-1 md:mx-4 flex-shrink-0"></div>
          
          <div className="flex-1 min-w-0">
            <p className="text-[10px] md:text-xs text-gray-500 mb-1">Starting at</p>
            <p className={`${styles.paragraph} mb-1`}>
              <span className="text-2xl md:text-3xl font-bold text-darkprimary">$260</span>
              <span className="text-xs md:text-base text-gray-600">/month</span>
            </p>
            <p className="text-[10px] md:text-sm text-gray-600">month-to-month</p>
          </div>
        </div>
        
        <p className={`${styles.paragraph} text-center`}>
          Pricing depends on hours per week & frequency · Scholarships accepted
        </p>
      </div>
    </div>
  );
};

export default FreeTrialPrograms;
